import { createAction, createReducer } from "@reduxjs/toolkit";

export const addColumn = createAction('addColumn')
export const addVarType = createAction('addVarType')
export const removeColumn = createAction('removeColumn')
export const removeVarType = createAction('removeVarType')
export const resetNewTable = createAction('resetNewTable')


const initialState = {
    columnName: [],
    varType: []
};

export const newTable = createReducer(initialState, {
    [addColumn]: (state, action) => {
        return{
            columnName: [...state.columnName, action.payload],
            varType: state.varType,
        }
    },
    [addVarType]: (state, action) => {
        return {
            columnName: state.columnName,
            varType: [...state.varType, action.payload]
        }
    },
    [removeColumn]: (state, action) => {
        return {
            columnName: state.columnName.filter(item => item !== action.payload),
            varType: state.varType
        } 
    },
    [removeVarType]: (state, action) => {
        return {
            columnName: state.columnName,
            varType: state.varType.filter(item => item !== action.payload)
        }
    },
    [resetNewTable]: () => {
        return {
            columnName: [],
            varType: []
        }
    }
}
);